// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"717e22c1","349":"49eb3331","876":"333caaa8"}[chunkId] + ".chunk.js";
};